package org.chiangmeng.qfast.features.auth

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
actual fun GoogleSignInButton(
    modifier: Modifier,
    enabled: Boolean,
    onTokenReceived: (idToken: String, accessToken: String?) -> Unit
) {
}
